export enum FormsTemplateType {
  FORM_MODULE = 'MODULE',
  FORM_STEP = 'STEP',
  FORM_TEMPLATE = 'COMPLETE_FORM',
}

export enum FormsTemplateStatus {
  DRAFT = 'DRAFT',
  LIVE = 'LIVE',
  COMPLETED = 'COMPLETED',
}
